import { render, staticRenderFns } from "./LargeCardAd.vue?vue&type=template&id=602d0180&scoped=true"
import script from "./LargeCardAd.vue?vue&type=script&lang=js"
export * from "./LargeCardAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602d0180",
  null
  
)

export default component.exports